export default __webpack_public_path__ + "static/anticimex_logo-8efbed9e64764e8644526003751a2957.png";